import type { NavigationGuardNext, Route } from "vue-router";

import { logInfo } from "@Resources/js/helpers/logger";
import { XUserTeamStore } from "@Resources/js/modules/teams/Store/XUserTeamStore";
import { isNullish } from "@tinyurldev/tu-ui-vue";

interface MiddlewareContext {
  to: Route | null
  next: NavigationGuardNext
  store: unknown
  nextMiddleware: () => void
}

export default function ({ nextMiddleware }: MiddlewareContext): void {
  const userTeam = XUserTeamStore();
  const defaultOrganization = userTeam.defaultOrganization;
  const defaultTeam = defaultOrganization?.defaultTeam();
  const shouldRedirectToTeamDashboard = userTeam.isTeamsAllowed && !isNullish(defaultTeam);

  if (shouldRedirectToTeamDashboard) {
    logInfo(`[shouldRedirectToTeams] Redirecting to your default team dashboard: ${defaultTeam.name}`);
    defaultTeam.visit();
    return;
  }

  nextMiddleware();
}
